<div #mainDiv_ll_model_cash_rules>

  <div *ngIf="bundle.showDisplay"
       [style.top.px]="bundle.remainingY"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       [style.height.px]="bundle.remainingH"
       style="position: absolute;">
    <ll-admin-generic-dg id="ll-model-cash-rules"></ll-admin-generic-dg>
  </div>


</div>
